import BaseAPIService from '@/services/baseAPIService'

export default class ContactAPIService extends BaseAPIService {
  constructor(httpClient, reportingHttpClient) {
    super(httpClient, reportingHttpClient)
  }

  // Contacts
  getContact(id)          { return this.httpClient.get(`/contacts/${id}`) }
  createContact(data)     { return this.httpClient.post(`/contacts`, data) }
  updateContact(id, data) { return this.httpClient.put(`/contacts/${id}`, data) }
  deleteContact(id)       { return this.httpClient.delete(`/contacts/${id}`) }
  archiveContact(id)       { return this.httpClient.put(`/contacts/${id}/archive`) }
  restoreContact(id)       { return this.httpClient.put(`/contacts/${id}/restore`) }
  getContactList(filterOptions = {})  {
    var filter = Object.keys(filterOptions).map(field => {
      return `${field}=` + encodeURIComponent(filterOptions[field])
    }).join('&')
    
    return this.cachedGet(`/contacts?${filter}`)
  }

  updateContactCreditStatus(id, data)   { return this.httpClient.put(`/contacts/${id}/credit/status`, data) }
  updateContactCreditDetails(id, data)  { return this.httpClient.put(`/contacts/${id}/credit`, data) }

  updateContactSupplier(id, data) { return this.httpClient.put(`/contacts/${id}/supplier`, data) }

  createContactAddress(contactId, data) { return this.httpClient.post(`/contacts/${contactId}/addresses`, data) }
  updateContactAddress(contactId, id, data) { return this.httpClient.put(`/contacts/${contactId}/addresses/${id}`, data) }
  deleteContactAddress(contactId, id) { return this.httpClient.delete(`/contacts/${contactId}/addresses/${id}`) }
  updateContactDefaultAddress(contactId, addressId) {
    return this.httpClient.put(`/contacts/${contactId}`, { defaultAddressId: addressId })
  }

  createContactPerson(contactId, data) { return this.httpClient.post(`/contacts/${contactId}/people`, data) }
  updateContactPerson(contactId, id, data) { return this.httpClient.put(`/contacts/${contactId}/people/${id}`, data) }
  deleteContactPerson(contactId, id) { return this.httpClient.delete(`/contacts/${contactId}/people/${id}`) }
  updateContactDefaultPerson(contactId, personId) {
    return this.httpClient.put(`/contacts/${contactId}`, { defaultPersonId: personId })
  }

  getSupplierContainerList(contactId) {
    return this.httpClient.get(`/contacts/${contactId}/supplier/containers`)
  }
  updateSupplierContainerList(contactId, data) {
    return this.httpClient.put(`/contacts/${contactId}/supplier/containers`, data)
  }

}
